module.exports = __webpack_public_path__ + "static/media/shopping-bag.0fd7dd97.svg";